import type { FaireProductEntity } from "../../entity_types/product";

export const p_s5q7zaft39: FaireProductEntity = {
  token: "p_s5q7zaft39",
  type: "product",
  name: "vintage bouquet mini enclosure notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/b6eba34999ca7fb42e266cc4ab82a236beb74eb00d83f9ee452fc04cd28ef149.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d0c09b60cb730afb947a52d12ad632e6aa3472962098331f37c366bba73f4983.jpeg",
  ],
  priceDollars: 2,
  description:
    'A mini notecard for petite greetings. Perfect for adding to a gift or popping in a gift card for a pretty (and easy!) presentation. \n\n\nDetails:\n\n- single card + envelope + sticker for sealing\n- blank inside\n- 2.5" x 3.5"\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:46.552Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
